import type { SlideProps } from "@/engine/app/offsite-config";

const LAYERS = [
  { step: "01", layer: "Experience Layer", systems: "Website, App, Portal, E-Mail" },
  { step: "02", layer: "Werkzeuge", systems: "Zendesk, Zendesk Telefonie" },
  { step: "03", layer: "Middleware", systems: "Make.com – Vermittler & Businesslogik zu Drittsystemen" },
  { step: "04", layer: "Kernsystem", systems: "kVASy – das Gedächtnis · AWS – Erweiterung (Anreicherung & Daten außerhalb kVASy)" },
];

export function Slide03Architektur(_: SlideProps) {
  return (
    <div className="deck-root dark" style={{ background: "var(--svo-dunkelblau)" }}>
      <div className="deck-bg" aria-hidden="true" />

      <header className="deck-head">
        <div className="deck-eyebrow rise rise-1">Architektur</div>
        <h1 className="deck-title rise rise-2">
          So hängt <br />
          <span className="accent">alles zusammen</span>
        </h1>
        <p className="deck-sub rise rise-3">Vier Schichten, ein Prinzip.</p>
      </header>

      <div className="arch-stack">
        {LAYERS.map((l, i) => (
          <div key={l.step} className={`arch-row rise rise-${Math.min(i + 3, 6)}`}>
            <div className="step">{l.step}</div>
            <div className="layer">{l.layer}</div>
            <div className="systems">{l.systems}</div>
          </div>
        ))}
      </div>

      <footer className="deck-foot">
        <span>Ein Prinzip</span>
        <span>Einmal automatisiert = funktioniert über jeden Kanal.</span>
      </footer>
    </div>
  );
}
